import {
  HomeModernIcon,
  FireIcon,
  ArrowsRightLeftIcon,
  MoonIcon,
  CalendarDaysIcon,
  CubeIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';

const areas = [
  { icon: HomeModernIcon, label: 'Bathrooms and fall-risk areas', detail: 'Grab bars, mats, lighting' },
  { icon: FireIcon, label: 'Kitchens and appliances', detail: 'Stove safety, reachability' },
  { icon: ArrowsRightLeftIcon, label: 'Entryways, stairs, and transitions', detail: 'Handrails, thresholds, visual contrast' },
  { icon: MoonIcon, label: 'Bedrooms and nighttime safety', detail: 'Path lighting, bed height' },
  { icon: CalendarDaysIcon, label: 'Daily routines and habits', detail: 'Consistency, movement patterns' },
  { icon: CubeIcon, label: 'Medication and mobility considerations', detail: 'Balance, side effects' },
  { icon: UserGroupIcon, label: 'Social connection and engagement', detail: 'Activity, isolation, staying connected' },
];

const RealHomeSection = () => {
  return (
    <div className="py-20 lg:py-28 bg-gradient-to-br from-background via-primary/3 to-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Works Room by Room,{' '}
            <span className="text-primary">and Day by Day</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Designed to fit real homes, real routines, and real life.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {areas.map((area, index) => (
            <div
              key={area.label}
              className={`group p-6 rounded-md bg-background shadow-raised hover:shadow-overlay transition-all duration-300 hover:-translate-y-0.5 ${
                index === areas.length - 1 && areas.length % 3 !== 0
                  ? 'sm:col-span-2 lg:col-span-1'
                  : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <area.icon className="w-7 h-7 text-primary flex-shrink-0" />
                <h3 className="text-foreground font-bold">{area.label}</h3>
              </div>
              <p className="text-xs text-muted-foreground pl-[52px]">{area.detail}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full">
            <span className="text-primary font-bold">
              One platform. One shared picture. No blind spots.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealHomeSection;
